<template>
    <div class="el-row tasks-list-wrapper">
        <div class="card-deal-header deals-list-header caption-block">
            <div class="title">
                {{ title }}
            </div>
            <transition name="slide-in">
                <column-settings v-if="columnSettingsShow" :columns-model="columnsModel" :attributes="attributes" />
            </transition>
            <transition name="slide-in">
                <filter-settings
                    v-show="filterSettingsShow"
                    :filter="filterModel"
                    :attributes="attributes"
                    :company-options="companyOptions"
                    @filterApplied="filterApplied"
                />
            </transition>
            <div class="actions deals-menu">
                <div :class="[ 'filter', 'icon-filter', 'icon' ]" @click="filterSettingsShow = !filterSettingsShow"></div>
                <div class="icon-settings icon" @click="columnSettingsShow = !columnSettingsShow"></div>
            </div>
        </div>
        <div class="contacts-info deals-info">
            <div :class="['row', 'filter', { 'no-filter' : !filterTitle }]">
                <div class="label">
                    Фильтрация по:
                </div>
                <div class="value" v-if="filterTitle">
                    {{ filterTitle }}
                </div>
                <div class="value" v-else>
                    нет
                </div>
            </div>
            <div class="row total-items">
                <div class="label">
                    Всего записей:
                </div>
                <div class="value">
                    {{ pagesInfo.total }}
                </div>
            </div>
        </div>
        <div class="contacts-list tasks-list">
            <div class="contacts-card tasks-card card" v-for="contact in contacts" :key="contact.id" @click="goToContact(contact.id)">
                <div class="row title" v-if="!attributes.name.hide">
                    <div class="value">
                        {{ contact.name ? contact.name : '' }}
                    </div>
                </div>
                <div class="row phones" v-if="!attributes.contact_phones.hide">
                    <div class="label">
                        {{ attributes.contact_phones.name | uppercase }}:
                    </div>
                    <template v-if="contact.contact_phones">
                        <div class="phones-list">
                            <div class="tel-item value" v-for="phone in contact.contact_phones" :key="phone.id">
                                {{ masker(phone.phone, '+# (###) ###-##-##', true, tokens) }}
                                <span class="icon-phone pointer pl10" @click="calltoPhone(phone.phone)">
                                    <font-awesome-icon icon="phone" class="orange" title="Позвонить" />
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="row" v-if="!attributes.email.hide">
                    <div class="label">
                        {{ attributes.email.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ contact.email ? contact.email : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.birthday.hide">
                    <div class="label">
                        {{ attributes.birthday.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ contact.birthday ? contact.birthday : '' }}
                    </div>
                </div>
                <div class="row" v-if="!attributes.company_id.hide">
                    <div class="label">
                        {{ attributes.company_id.name | uppercase }}:
                    </div>
                    <div class="value">
                        {{ contact.company.name ? contact.company.name : '' }}
                    </div>
                </div>
            </div>
            <div class="pagination-wrapper">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :pager-count="5"
                    @current-change="getCurrentPage"
                />
            </div>
        </div>
        <ag-grid-vue
            class="fake-grid"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
        />
    </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import { eventBus } from '@/common/eventBus';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import ColumnSettings from '@/components/ColumnSettingsMobile';
import FilterSettings from './FilterSettingsMobile';
import defaultSettings from './defaultSettings';
import { pickerOptions } from '@/common/pickerOptions';
import masker from '@/components/vue-the-mask/src/masker';
import moment from 'moment';

library.add(faPhone);
const tokens = {
    '#': { pattern: /\d/ },
    'X': { pattern: /[0-9a-zA-Z]/ },
    'S': { pattern: /[a-zA-Z]/ },
    'A': { pattern: /[a-zA-Z]/, transform: v => v.toLocaleUpperCase() },
    'a': { pattern: /[a-zA-Z]/, transform: v => v.toLocaleLowerCase() },
    '!': { escape: true }
};

export default {
    name: 'ContactsListMobile',
    data() {
        return {
            title: 'Список контактов',
            columnSettingsShow: false,
            filterSettingsShow: false,
            defaultSettings: defaultSettings,
            columnsModel: [],
            sortModel: {},
            filterModel: {
                name: null,
                phone: null,
                email: null,
                birthday: null,
                company_id: []
            },
            attributes: {
                'name': {
                    hide: false,
                    name: 'имя контакта'
                },
                'contact_phones': {
                    hide: false,
                    name: 'телефон'
                },
                'email': {
                    hide: false,
                    name: 'e-mail'
                },
                'birthday': {
                    hide: false,
                    name: 'день рождения'
                },
                'company_id': {
                    hide: false,
                    name: 'компания'
                },
                '0': {
                    hide: false,
                    name: 'Иконка настроек'
                }
            },
            fieldsNames: {},
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            totalRows: 0,
            loading: true,
            pickerOptions,
            companyOptions: [],
            columnDefs: [],
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    comparator: () => {
                        return 0;
                    },
                    cellClass: 'column-text'
                }
            },
            tokens
        };
    },
    components: {
        ColumnSettings,
        FilterSettings,
        AgGridVue
    },
    computed: {
        contacts() {
            return this.$store.state.contacts.contacts;
        },
        pagesInfo() {
            return this.$store.state.contacts.pages;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        companies() {
            return this.$store.state.references.companies;
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    const getNamesFrom = (obj) => {
                        if (Object.keys(obj).length !== 0) {
                            return (this.fieldsNames[field] + ': ' + this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ') + '; ');
                        } else {
                            return '';
                        }
                    };
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'company_id':
                                result += getNamesFrom(this.companies);
                                break;
                            case 'phone':
                                result += this.fieldsNames.contact_phones + ': ' + this.filterModel[field] + '; ';
                                break;
                            default:
                                result += (this.fieldsNames[field] + ': ' + this.filterModel[field] + '; ');
                        }
                    }
                    if (field === 'birthday') {
                        result += this.fieldsNames[field] + ': ' + moment(this.filterModel[field]).format('DD.MM.YYYY') + '; ';
                    }
                }
            }
            return result;
        }
    },
    mounted() {
        Object.keys(this.attributes).forEach((item) => {
            this.$set(this.fieldsNames, item, this.attributes[item].name);
        });

        this.$store.dispatch('preferences/getPreferences').then(
            () => {
                this.setSettings();
            }).catch(
            error => {
                console.log(error);
            }).finally(() => {
            this.getDataFromServer();
        });
    },
    methods: {
        setSettings() {
            let settings;
            if (!this.setting || !this.setting.contacts) {
                settings = this.defaultSettings.contacts;
            } else {
                settings = this.setting.contacts;
            }

            this.filterModel = JSON.parse(JSON.stringify(settings.filter));
            this.pageModel = JSON.parse(JSON.stringify(settings.page));
            this.columnsModel = JSON.parse(JSON.stringify(settings.table));
            this.setColumnsList(this.columnsModel);
        },
        setColumnsList(columnSettings) {
            columnSettings.forEach((item) => {
                const colName = item.colId;
                if (Object.prototype.hasOwnProperty.call(this.attributes, colName)) {
                    this.attributes[colName].hide = item.hide;
                }
            });
        },
        getLinkElement(id, name, route, elementType, className) {
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
                element.innerText = name;
            }
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: [
                    {
                        colId: 'id', sort: 'desc'
                    }
                ],
                filter: this.filterModel
            };
            this.loading = true;
            this.$store.dispatch('contacts/getPaginatedList', requestParams).then(
                response => {
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                    this.loading = false;
                }).catch(
                error => {
                    if (error.response) {
                        this.loading = false;
                    }
                }).finally(() => {
                this.companyOptions = JSON.parse(JSON.stringify(this.companies));
            });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
            this.scrollToTop();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        async saveSetting(table = this.columnsModel, filter = this.filterModel) {
            const data = {
                'contacts': {
                    'table': table,
                    'sort': {
                        colId: 'id', sort: 'desc'
                    },
                    'filter': this.filterModel,
                    'page': this.pageModel
                }
            };
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        goToContact(id) {
            const route = {
                name: 'contact-card',
                params: { id: id }
            };

            this.$router.push(route);
        },
        calltoPhone(phone) {
            this.loading = true;
            this.$store.dispatch('voip/callToPhone', { phone: phone }).then(
                response => {
                    console.log('response', response.data.data);
                    this.$message({
                        showClose: true,
                        message: 'Начат звонок на номер ' + phone,
                        type: 'success',
                        duration: 3000,
                        customClass: this.alertClass()
                    });
                    this.errors = {};
                },
                error => {
                    console.log('error', error.response.data);
                    this.$message({
                        showClose: true,
                        message: 'Ошибка при звоноке на номер ' + phone,
                        type: 'error',
                        duration: 1500,
                        customClass: this.alertClass()
                    });
                }
            ).finally(() => { this.loading = false; });
        },
        masker
    },
    created() {
        eventBus.$on('hideColumnSettings', () => {
            this.columnSettingsShow = false;
            this.scrollToTop();
        });
        eventBus.$on('hideFilterSettings', () => {
            this.filterSettingsShow = false;
            this.scrollToTop();
        });
        eventBus.$on('newColumnSettings', table => {
            this.saveSetting(table).then(
                () => {
                    this.setSettings();
                }).catch(
                error => {
                    console.log(error);
                });
        });

        Object.keys(this.attributes).forEach((item) => {
            this.columnDefs.push({ headerName: '', field: item });
        });
    },
    filters: {
        uppercase: function(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
};
</script>
